import { useEffect, useState } from 'react';
import { getPosicaoAtualFundo } from '../services/carteiraDiariaService';
import { PosicaoAtualFundoResponse } from '../types/carteiraDiaria';

export interface UsePosicaoAtualFundoReturn {
  data: PosicaoAtualFundoResponse | null;
  setData: React.Dispatch<React.SetStateAction<PosicaoAtualFundoResponse | null>>;
  loading: boolean;
  error: string | null;
}

export const usePosicaoAtualFundo = (
  fundoId: number,
  isOpen: boolean,
  selectedDate: string,
): UsePosicaoAtualFundoReturn => {
  const [data, setData] = useState<PosicaoAtualFundoResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isOpen) return;
    setLoading(true);
    setError(null);
    setData(null);
    getPosicaoAtualFundo(fundoId, selectedDate || undefined)
      .then(setData)
      .catch(() => setError('Não foi possível carregar a posição do fundo.'))
      .finally(() => setLoading(false));
  }, [isOpen, fundoId, selectedDate]);

  return { data, setData, loading, error };
};
